import { render } from "./LegalUserConsentModal.vue?vue&type=template&id=1127e2d0&scoped=true"
import script from "./LegalUserConsentModal.vue?vue&type=script&lang=js"
export * from "./LegalUserConsentModal.vue?vue&type=script&lang=js"

import "./LegalUserConsentModal.vue?vue&type=style&index=0&id=1127e2d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1127e2d0"]])

export default __exports__